import { useCallback, useState } from 'react'

const pageTransitionDelay = 0

export const useDelayedContinue = (): {
  isAnswersDisabled: boolean
  handleChange: (
    value: string | string[] | null,
    handleContinue: (value: string | string[]) => void,
  ) => void
  setIsAnswersDisabled: (value: boolean) => void
} => {
  const [isAnswersDisabled, setIsAnswersDisabled] = useState<boolean>(false)

  const handleChange = useCallback((value, handleContinue) => {
    setTimeout(() => {
      handleContinue(value)
      setIsAnswersDisabled(false)
    }, pageTransitionDelay)
  }, [])

  return { isAnswersDisabled, handleChange, setIsAnswersDisabled }
}
